// packages/utils/src/shared/result.ts
import type { Result, ResultError } from '@tourtask/types/result';

/**
 * Runtime-safe Result helpers.
 * (Keep @tourtask/types as types-only; do NOT import runtime values from it.)
 */

export function success<T>(data: T): Result<T> {
  return { success: true, data } as Result<T>;
}

export function failure<T = never>(error: ResultError): Result<T> {
  return { success: false, error } as Result<T>;
}
